var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnaiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 38,
    viewBox: "0 0 150 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2402 16.9132H40.4202V36.8145H34.3525L32.2442 33.3025C28.9533 36.2547 24.8225 37.7307 19.8518 37.7307C16.3552 37.7307 13.1328 37.086 10.1847 35.7966C7.2708 34.5071 4.87115 32.5221 2.98572 29.8414C1.13456 27.1608 0.208984 24.005 0.208984 20.3743V17.6257C0.208984 12.1965 2.14584 7.95499 6.01955 4.90107C9.92755 1.81321 14.8297 0.269287 20.726 0.269287C25.2853 0.269287 29.1933 1.20243 32.4499 3.06871C35.7066 4.935 37.9177 7.47993 39.0832 10.7035L29.2618 13.2993C28.5419 11.6367 27.4107 10.3303 25.868 9.38015C24.3597 8.43004 22.5942 7.95499 20.5717 7.95499C17.8292 7.95499 15.5667 8.76937 13.7841 10.3981C12.0015 11.9929 11.1102 14.3004 11.1102 17.3203V20.6797C11.1102 23.5978 12.0015 25.8883 13.7841 27.551C15.601 29.2137 17.8978 30.045 20.6745 30.045C24.9253 30.045 27.942 27.9582 29.7246 23.7845H21.2402V16.9132Z",
    fill: "#F1935C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7807 36.8145V1.18546H57.0135L75.4736 21.3413H75.5764V1.18546H85.7578V36.8145H75.885L57.0649 16.2006H56.9621V36.8145H46.7807Z",
    fill: "#F1935C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.503 36.8145L122.394 31.5211H103.369L101.209 36.8145H89.9478L106.351 0.880072H120.286L136.432 36.8145H124.503ZM106.505 23.9372H119.361L113.036 8.20948H112.933L106.505 23.9372Z",
    fill: "#F1935C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.826 6.74755V0.269287H149.693V6.74755H139.826ZM139.826 36.6971V10.186H149.693V36.6971H139.826Z",
    fill: "#34656D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnaiLogo);
export default __webpack_public_path__ + "static/media/gnai_logo.f75178558a4c8b8b0d38b8bad55c9ae5.svg";
export { ForwardRef as ReactComponent };